class SliderWithChangeOnHover {

    constructor($element) {

        /**
         * root element
         * @type {HTMLElement | jQuery}
         */
        this.$ELEMENT = $element instanceof jQuery ? $element : $($element);
        this.SLIDES = this.$ELEMENT.find('.glide__slide');

        if (this.SLIDES.length <= 0) {
            return;
        }

        this.SLIDER_OPTIONS = {
            type: 'carousel',
            perView: 1,
            gap: 0,
            animationDuration: 0
        }

        this.SLIDER;

        const _this = this;
        this.initComponents()
            .then(_ => {
                    // declare event listeners of glide-slider before calling mount() method
                    _this.registerHooks().then(_ => {
                        _this.mountSlider();
                    });
                }, error => {
                    console.error(error)
                }
            );
    }

    /**
     * initialize child components of SliderWithChangeOnHover
     * @returns {Promise<>}
     */
    initComponents() {
        const _this = this;
        return new Promise((resolve, reject) => {
            _this.SLIDER = new Glide(_this.$ELEMENT[0], _this.SLIDER_OPTIONS);
            resolve();
        })
    }

    /**
     * register EventListener of SliderWithChangeOnHover
     * @returns {Promise<unknown>}
     */
    registerHooks() {
        const _this = this;
        return new Promise((resolve, reject) => {
            _this.$ELEMENT.find('.js-slider-preview-button')
                .mouseenter(function () {
                    let direction = $(this).attr('data-glide-dir');
                    _this.SLIDER.go(direction);
                })
                .on('click', function () {
                    window.location = $(this).find('a').attr('href');
                })
            resolve();
        });
    }

    /**
     * mount slider
     */
    mountSlider() {
        if (this.SLIDER) {
            this.SLIDER.mount();
        }
    }
}
